module.exports = __webpack_public_path__ + "img/zw.2382684f.svg";